interface TypographyProps {
    children: React.ReactNode;
    className?: string;
}

export const BodyXLMedium = ({ children, className = '' }: TypographyProps) => {
    return (
        <p className={`font-outfit text-base font-medium leading-6 lg:text-xl ${className}`}>
            {children}
        </p>
    );
};